// Persists the JWT pair in localStorage.
//
// Deliberately has no dependency on the axios instance so that axios.js and
// user.model.js can both import it without creating an import cycle.

const ACCESS_KEY = 'portal-access-token';
const REFRESH_KEY = 'portal-refresh-token';
// Pre-JWT DRF token. No longer accepted by the API; removed on load.
const LEGACY_KEY = 'portal-token';

const safeStorage = () => {
  try {
    return window.localStorage;
  } catch (_) {
    return null;
  }
};

export const tokenStorage = {
  getAccess() {
    return safeStorage()?.getItem(ACCESS_KEY) || null;
  },

  getRefresh() {
    return safeStorage()?.getItem(REFRESH_KEY) || null;
  },

  // `refresh` is optional so callers that only get a new access token don't
  // wipe the stored refresh token.
  set(access, refresh) {
    const storage = safeStorage();
    if (!storage) return;
    if (access) storage.setItem(ACCESS_KEY, access);
    if (refresh) storage.setItem(REFRESH_KEY, refresh);
  },

  clear() {
    const storage = safeStorage();
    if (!storage) return;
    storage.removeItem(ACCESS_KEY);
    storage.removeItem(REFRESH_KEY);
    storage.removeItem(LEGACY_KEY);
  },
};

safeStorage()?.removeItem(LEGACY_KEY);
